const initialState = {
	versions: null,
	recipients: null,
	recipientsDict: {},
	titleTypes: null,
	categories: null,
	categoriesDict: {},
	allTitleTypes: null,
	accountTypes: null,
	userRoles: null,
	menuResources: null,
};

export function data(state = initialState, action) {
	switch (action.type) {
		case 'RECEIVE_VERSIONS':
			return {
				...state,
				versions: action.payload,
			};
		case 'RECEIVE_RECIPIENTS': {
			let dictToSet = {};
			for (let i = 0; i < action.payload.length; ++i) {
				dictToSet[action.payload[i].code] = action.payload[i].label;
			}

			return {
				...state,
				recipients: action.payload,
				recipientsDict: dictToSet,
			};
		}
		case 'RECEIVE_TITLE_TYPES':
			return {
				...state,
				titleTypes: action.payload,
			};
		case 'RECEIVE_CATEGORIES': {
			let dictToSet = {};
			for (let i = 0; i < action.payload.length; ++i) {
				dictToSet[action.payload[i].code] = action.payload[i].label;
			}

			return {
				...state,
				categories: action.payload,
				categoriesDict: dictToSet,
			};
		}
		case 'RECEIVE_ALL_TITLE_TYPES':
			return {
				...state,
				allTitleTypes: action.payload,
			};
		case 'RECEIVE_ACCOUNT_TYPES':
			return {
				...state,
				accountTypes: action.payload,
			};
		case 'RECEIVE_USER_ROLES':
			return {
				...state,
				userRoles: action.payload,
			};
		case 'RECEIVE_MENU_RESOURCES':
			return {
				...state,
				menuResources: action.payload,
			};
		
		default:
			return state;
	}

}